// src/components/PageTransition.jsx
import { motion } from 'framer-motion';
import { springs } from '../lib/motion';

// Opacity-only entrance: animating a transform (y) here makes this wrapper the
// containing block for the pages' position:fixed headers, so the top bar
// mis-positions during the spring and snaps into place when transform resets.
const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export function PageTransition({ children, className = '' }) {
  return (
    <motion.div
      className={className}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      transition={springs.content}
    >
      {children}
    </motion.div>
  );
}
